import { config } from "../config";

const { products } = config.shopify;

export const MATIC_PRODUCT_ID = products.matic;
export const MATIC_VARIANT_ID = products.maticVariant;
export const MATIC_CARE_PRODUCT_ID = products.care;
export const MATIC_CARE_VARIANT_ID = products.careVariant;
export const MATIC_BAG_PASS_PRODUCT_ID = products.bagPass;
export const MATIC_BAG_PASS_VARIANT_ID = products.bagPassVariant;
export const MATIC_REFERRAL_BAG_PASS_PRODUCT_ID = products.referralBagPass;
export const MATIC_REFERRAL_BAG_PASS_VARIANT_ID =
  products.referralBagPassVariant;
export const MATIC_REFKIT_VARIANT_ID = products.refkitVariant;
export const MATIC_BUILDER_KIT_PRODUCT_ID = products.builderKit;
export const MATIC_BUILDER_KIT_VARIANT_ID = products.builderKitVariant;
export const MATIC_STICKER_KIT_PRODUCT_ID = products.stickerKit;
export const MATIC_STICKER_KIT_VARIANT_ID = products.stickerKitVariant;
export const MATIC_RACE_CAR_STICKERS_PRODUCT_ID = products.raceCarStickers;
export const MATIC_RACE_CAR_STICKERS_VARIANT_ID =
  products.raceCarStickersVariant;
export const PET_BRUSH_ROLL_PRODUCT_ID = products.petBrushRoll;
export const PET_BRUSH_ROLL_VARIANT_ID = products.petBrushRollVariant;
export const MATIC_DOCK_PRODUCT_ID = products.dock;
export const MATIC_DOCK_VARIANT_ID = products.dockVariant;
export const MATIC_SERENE_PRODUCT_ID = products.maticSerene;
export const MATIC_SERENE_VARIANT_ID = products.maticSereneVariant;
// Dock variant price ($98). Only the dock's variant ID is configured (no
// product ID), so the PDP can't fetch its price; keep this in sync with the
// Shopify Dock variant price.
export const MATIC_DOCK_UNIT_AMOUNT = 98;
export const BUNDLE_PRODUCT_IDS = products.bundleProductIds;
export const ACCESSORY_PRODUCT_IDS = products.accessoryProductIds;

export type BagKind = "ir" | "rs";

/** The IR and RS variant of every product that contains HEPA bags. */
export type BagProductVariants = Record<BagKind, string>;

const BAG_PRODUCT_VARIANTS: readonly BagProductVariants[] = [
  // hepa-bag-4x
  {
    ir: "gid://shopify/ProductVariant/45090599207112",
    rs: "gid://shopify/ProductVariant/45090599239880",
  },
  // hepa-bag-12x
  {
    ir: "gid://shopify/ProductVariant/45090598879432",
    rs: "gid://shopify/ProductVariant/45090598912200",
  },
  // hepa-bags
  {
    ir: "gid://shopify/ProductVariant/45090600485064",
    rs: "gid://shopify/ProductVariant/45090600517832",
  },
  // accessory-kit
  {
    ir: "gid://shopify/ProductVariant/45090598093000",
    rs: "gid://shopify/ProductVariant/45090598125768",
  },
  // bag-bundle-referral-edition-copy
  {
    ir: "gid://shopify/ProductVariant/45090597699784",
    rs: "gid://shopify/ProductVariant/45090597732552",
  },
  // starter-kit (archived)
  {
    ir: "gid://shopify/ProductVariant/45090598650056",
    rs: "gid://shopify/ProductVariant/45090598682824",
  },
  // premium-kit (archived)
  {
    ir: "gid://shopify/ProductVariant/45090599698632",
    rs: "gid://shopify/ProductVariant/45090599731400",
  },
  // standard-kit (archived)
  {
    ir: "gid://shopify/ProductVariant/45090599960776",
    rs: "gid://shopify/ProductVariant/45090599993544",
  },
  // essential-kit (archived)
  {
    ir: "gid://shopify/ProductVariant/45090600124616",
    rs: "gid://shopify/ProductVariant/45090600157384",
  },
];

/** Either variant GID of a bag product -> both of that product's variants. */
export const BAG_PRODUCT_BY_VARIANT: Record<string, BagProductVariants> =
  Object.fromEntries(
    BAG_PRODUCT_VARIANTS.flatMap((product) => [
      [product.ir, product],
      [product.rs, product],
    ]),
  );

export const DISCOUNTS: Record<string, string> = {
  MATIC50: "50",
  MATICVIP: "100",
  LUKASZIEGLER: "50",
  BOOTH: "100",
  DOCK20: "20",
  MATICDOGFEST50: "50",
};
